export default __webpack_public_path__ + "static/media/medlogohori.b2723b44.png";